import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import QuickContact from './QuickContact';

export default function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer id="contact">
      <QuickContact />
      <div className="relative h-[280px] overflow-hidden">
        <img src="https://public.readdy.ai/ai/img_res/edited_13fa343293dcf73a5e386be3c1c2afa5_708bd178.jpg" alt="Rice field panorama" title="Grow with EverRice" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-background-50/30" />
        <div className="relative h-full flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between gap-6 page-gutter">
          <h2 className="font-heading text-3xl md:text-[calc(3rem_-_1px)] leading-tight max-w-lg md:max-w-3xl whitespace-pre-line">{t('footer.heading')}</h2>
          <Link to="/contact#send-message" className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-xs tracking-widest uppercase whitespace-nowrap cursor-pointer">{t('footer.cta')} <i className="ri-arrow-right-line" /></Link>
        </div>
      </div>
      <div className="bg-primary-50 page-gutter py-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4 text-xs text-foreground-700">
        <div className="flex items-center gap-2">
          <span className="w-4 h-4 flex items-center justify-center text-foreground-700"><i className="ri-copyright-line text-sm" /></span>
          <p className="whitespace-nowrap">{t('footer.company')}</p>
        </div>
        <p className="flex flex-wrap gap-4"><span>{t('footer.email')}</span><span>{t('footer.location')}</span></p>
      </div>
    </footer>
  );
}